import { useTranslate } from 'hooks/useTranslate';
import ToggleMenu from 'modules/_shared/components/ToggleMenu';
import { FC } from 'react';
import { Folder } from 'types';
import { badgeStyles } from 'modules/_shared/constants/badgeStyles';
import FolderIcon from './FolderIcon';
import { useMyFolders } from '../context/MyFolders';

type FolderCardProps = {
  index: number;
  folder: Folder;
};

const FolderCard: FC<FolderCardProps> = ({ index, folder }) => {
  const { t } = useTranslate();

  const { actions } = useMyFolders();

  const handleClick = () => {
    actions.handleOpenFolder(index);
  };

  const handleEdit = () => {
    actions.handleEditFolder(index);
  };

  const handleDownload = () => {};

  const handleDelete = () => {
    actions.handleDeleteFolder(index);
  };

  const colorClass = `text-${folder.style || badgeStyles[0]}`;
  const documentsCount = folder.documentsCount?.total || 0;

  const foldersCount = folder.foldersCount?.total || 0;

  const toggleOptions = [
    <a
      className="d-flex cursor-pointer"
      key={`folder-edit-option-${index}`}
      onClick={handleEdit}
    >
      <em className="icon ni ni-edit fs-20px" />
      <span className="ml-1">{t('Edit')}</span>
    </a>,
    // <a
    //   className="d-flex cursor-pointer"
    //   key={`folder-download-option-${index}`}
    //   onClick={handleDownload}
    // >
    //   <em className="icon ni ni-download fs-20px" />
    //   <span className="ml-1">{t('Download')}</span>
    // </a>,
    <a
      className="d-flex cursor-pointer"
      key={`folder-delete-option-${index}`}
      onClick={handleDelete}
    >
      <em className="icon ni ni-trash fs-20px" />
      <span className="ml-1">{t('Delete')}</span>
    </a>,
  ];

  return (
    <div className="folder-card" onClick={handleClick}>
      <div
        className="folder-card__more-btn"
        onClick={(e) => e.stopPropagation()}
      >
        <ToggleMenu toggleOptions={toggleOptions} />
      </div>
      <span className={`folder-card__icon ${colorClass}`}>
        <FolderIcon />
      </span>
      <span className="folder-card__name">{folder.name}</span>
      <div className="folder-card__meta">
        {foldersCount > 0 && (
          <span className="folder-card__stat">
            <em className="icon ni ni-folder" />
            {foldersCount}
          </span>
        )}
        {documentsCount > 0 && (
          <span className="folder-card__stat">
            <em className="icon ni ni-file-text" />
            {documentsCount}
          </span>
        )}
        {!foldersCount && !documentsCount && (
          <span className="folder-card__stat folder-card__stat--empty">
            {t('Empty')}
          </span>
        )}
      </div>
    </div>
  );
};

export default FolderCard;
